import {useMutation} from '@apollo/client'
import clsx from 'clsx'
import {useFormik} from 'formik'
// import {Link} from 'react-router-dom'
import * as Yup from 'yup'
import {IUserLogin} from '../../graphql/types/loginTypes'
import {LOGIN} from '../../graphql/mutations/loginMutation'
import {useEffect, useState} from 'react'
import {useGetUser} from '../../context/useGetUser'
import {Alert} from 'react-bootstrap'

const loginSchema = Yup.object().shape({
  email: Yup.string()
    .email('Correo incorrecto')
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Obligatorio'),
  password: Yup.string()
    .min(3, 'Minimo 3 caracteres')
    .max(50, 'Máximo 50 caracteres')
    .required('Obligatorio'),
})

export const LoginPage = () => {
  const [gqlLogin, {data, loading, error}] = useMutation<IUserLogin>(LOGIN)

  const [show, setShow] = useState(false)

  const {login} = useGetUser()

  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
    },
    validationSchema: loginSchema,
    onSubmit: ({email, password}) => {
      gqlLogin({
        variables: {
          email,
          password,
        },
      })
    },
  })

  useEffect(() => {
    if (data) {
      login(data)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  const handleClick = () => setShow(!show)

  return (
    <form
      className='form w-100'
      onSubmit={formik.handleSubmit}
      noValidate
      id='kt_login_signin_form'
    >
      {/* begin::Heading */}
      <div className='text-center mb-11'>
        <h1 className='text-dark fw-bolder mb-3'>Bienvenido</h1>
        <div className='text-gray-500 fw-semibold fs-6'>Administra tus usuarios</div>
      </div>
      {/* begin::Heading */}

      <div>{error && <Alert variant='danger'>{error.message}</Alert>}</div>

      {/* begin::Separator */}
      <div className='separator separator-content my-14'>
        <span className='w-125px text-gray-500 fw-semibold fs-7'>Credenciales</span>
      </div>
      {/* end::Separator */}

      {/* begin::Form group */}
      <div className='fv-row mb-8'>
        <label className='form-label fs-6 fw-bolder text-dark'>Correo</label>
        <input
          placeholder='ejemplo@correo.com'
          {...formik.getFieldProps('email')}
          className={clsx(
            'form-control bg-transparent',
            {'is-invalid': formik.touched.email && formik.errors.email},
            {
              'is-valid': formik.touched.email && !formik.errors.email,
            }
          )}
          type='email'
          name='email'
          // autoComplete='off'
        />
        {formik.touched.email && formik.errors.email && (
          <div className='fv-plugins-message-container text-danger'>
            <span role='alert'>{formik.errors.email}</span>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group */}
      <div className='fv-row mb-3 position-relative'>
        <label className='form-label fw-bolder text-dark fs-6 mb-0'>Contraseña</label>
        <input
          type={show ? 'text' : 'password'}
          autoComplete='off'
          placeholder='••••••'
          {...formik.getFieldProps('password')}
          className={clsx(
            'form-control bg-transparent',
            {
              'is-invalid': formik.touched.password && formik.errors.password,
            },
            {
              'is-valid': formik.touched.password && !formik.errors.password,
            }
          )}
        />
        <div
          className='position-absolute'
          style={{
            bottom: formik.touched.password && formik.errors.password ? '37%' : '16%',
            right: formik.touched.password ? '10%' : '4%',
            zIndex: 10,
          }}
        >
          <button type='button' className='border-0 p-0 m-0 bg-transparent' onClick={handleClick}>
            {show ? (
              <i className='bi bi-eye-slash-fill fs-4 text-dark' />
            ) : (
              <i className='bi bi-eye-fill fs-4 text-warning' />
            )}
          </button>
        </div>
        {formik.touched.password && formik.errors.password && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.password}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Wrapper */}
      <div className='d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-8'>
        <div />

        {/* begin::Link */}
        {/* <Link to='/auth/forgot-password' className='link-primary'>
          Forgot Password ?
        </Link> */}
        {/* end::Link */}
      </div>
      {/* end::Wrapper */}

      {/* begin::Action */}
      <div className='d-grid mb-10'>
        <button
          type='submit'
          id='kt_sign_in_submit'
          className='btn'
          style={{backgroundColor: '#d9a32f', color: 'white'}}
          disabled={!formik.isValid || loading}
        >
          {/* {!loading && <span className='indicator-label'>Continue</span>}*/}
          {loading ? (
            <span className='indicator-progress' style={{display: 'block'}}>
              Ingresando...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          ) : (
            <span className='indicator-label'>Ingresar</span>
          )}
        </button>
      </div>
      {/* end::Action */}

      {/* <div className='text-gray-500 text-center fw-semibold fs-6'>
        Not a Member yet?{' '}
        <Link to='/auth/registration' className='link-primary'>
          Sign up
        </Link>
      </div> */}
    </form>
  )
}
